export default "__VITE_ASSET__575fbfdc__"